import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
    GET_ORGANIZATIONS,
    LOAD_ORGANIZATIONS,
    SG_GET_ORGANIZATION_SELECT,
    GET_ORGANIZATION_SELECT,
    FETCH_ORGANIZATION_PRIMARY,
    SG_FETCH_ORGANIZATION_PRIMARY,
    DELETE_ORGANIZATION,
    REMOVE_ORGANIZATION,
    PULL_ORGANIZATION,
    FETCH_ORGANIZATION,
    UPDATE_ORGANIZATION,
    EDIT_ORGANIZATION,
    SAVE_ORGANIZATION,
    ADD_ORGANIZATION,
    UPDATE_ORGANIZATION_LOGO,
    EDIT_ORGANIZATION_LOGO,
    GET_ORGANIZATION_STYLE,
    SG_GET_ORGANIZATION_STYLE,
    VALIDATE_ORGANIZATION,
    SG_VALIDATE_ORGANIZATION,
    ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadorganizations(action) {
  try {
    const json = yield call(api.GET_ORGANIZATIONS, action.payload);
    yield put({ type: GET_ORGANIZATIONS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationLoad() {
  yield takeLatest(LOAD_ORGANIZATIONS, loadorganizations);
}

function* loadorganizationselect(action) {
    try {
      const json = yield call(api.GET_ORGANIZATION_SELECT, action.payload);
      yield put({ type: GET_ORGANIZATION_SELECT, payload: json.data });
  
    } catch (e) {
      yield call(handleError, e);
    }
  }
  
  export function* organizationSelectLoad() {
    yield takeLatest(SG_GET_ORGANIZATION_SELECT, loadorganizationselect);
  }

  function* loadorganizationPrimary(action) {
    try {
      const json = yield call(api.FETCH_ORGANIZATION_PRIMARY, action.payload);
      yield put({ type: FETCH_ORGANIZATION_PRIMARY, payload: json.data });
  
    } catch (e) {
      yield call(handleError, e);
    }
  }
  
  export function* organizationPrimaryLoad() {
    yield takeLatest(SG_FETCH_ORGANIZATION_PRIMARY, loadorganizationPrimary);
  }

function* loadorganizationStyle(action) {
  try {
    const json = yield call(api.GET_ORGANIZATION_STYLE, action.payload);
    yield put({ type: GET_ORGANIZATION_STYLE, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationStyleLoad() {
  yield takeLatest(SG_GET_ORGANIZATION_STYLE, loadorganizationStyle);
}

function* fetchorganizations(action) {
  try {
    const json = yield call(api.FETCH_ORGANIZATION, action.payload);
    yield put({ type: FETCH_ORGANIZATION, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationFetch() {
  yield takeLatest(PULL_ORGANIZATION, fetchorganizations);
}


function* updateorganizations(action) {
  try {
    const json = yield call(api.EDIT_ORGANIZATION, action.payload);
    yield put({ type: EDIT_ORGANIZATION, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationUpdate() {
  yield takeLatest(UPDATE_ORGANIZATION, updateorganizations);
}


function* updateorganizationlogo(action) {
  try {
    const json = yield call(api.ADD_ORGANIZATION_LOGO, action.payload);
    yield put({ type: EDIT_ORGANIZATION_LOGO, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationlogoUpdate() {
  yield takeLatest(UPDATE_ORGANIZATION_LOGO, updateorganizationlogo);
}

function* addorganizations(action) {
  try {
    const json = yield call(api.ADD_ORGANIZATION, action.payload);
    yield put({ type: ADD_ORGANIZATION, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationAdd() {
  yield takeLatest(SAVE_ORGANIZATION, addorganizations);
}

function* deleteorganizations(action) {
  try {
    const json = yield call(api.DELETE_ORGANIZATION, action.payload);
    yield put({ type: DELETE_ORGANIZATION, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* organizationDelete() {
  yield takeLatest(REMOVE_ORGANIZATION, deleteorganizations);
}

function* validateorganizations(action) {
    try {
      const json = yield call(api.VALIDATE_ORGANIZATION, action.payload);
      yield put({ type: VALIDATE_ORGANIZATION, payload: json.data });
  
    } catch (e) {
      yield call(handleError, e);
    }
  }
  
  export function* organizationValidate() {
    yield takeLatest(SG_VALIDATE_ORGANIZATION, validateorganizations);
  }

export default function* index() {
  yield all([
    organizationLoad(),
    organizationSelectLoad(),
    organizationPrimaryLoad(),
    organizationStyleLoad(),
    organizationFetch(),
    organizationUpdate(),
    organizationlogoUpdate(),
    organizationAdd(),
    organizationDelete(),
    organizationValidate()
  ]);
}
